import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";

const RemovableProjectCode = (props: RemovableProps<string>) => {
  return <RemovableLabel {...props}>
    <div>
      {props.value}
    </div>
  </RemovableLabel>;
};

export default RemovableProjectCode;